import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../packages/react/src/drafts/MarkdownEditor/MarkdownEditor.docs.json';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {MarkdownEditor} from '@primer/react/drafts'
`}</code></pre>
    <p><inlineCode parentName="p">{`MarkdownEditor`}</inlineCode>{` is a full-featured editor for GitHub Flavored Markdown, with support for:`}</p>
    <ul>
      <li parentName="ul">{`Formatting (keyboard shortcuts & toolbar buttons)`}</li>
      <li parentName="ul">{`File uploads (drag & drop, paste, click to upload)`}</li>
      <li parentName="ul">{`Inline suggestions (emojis, `}<inlineCode parentName="li">{`@`}</inlineCode>{` mentions, and `}<inlineCode parentName="li">{`#`}</inlineCode>{` references)`}</li>
      <li parentName="ul">{`Saved replies`}</li>
      <li parentName="ul">{`Markdown pasting (ie, paste URL onto selected text to create a link)`}</li>
      <li parentName="ul">{`List editing (create a new list item on `}<inlineCode parentName="li">{`Enter`}</inlineCode>{`)`}</li>
      <li parentName="ul">{`Indenting selected text`}</li>
    </ul>
    <h2>{`Examples`}</h2>
    <h3>{`Minimal Example`}</h3>
    <p>{`A `}<inlineCode parentName="p">{`Label`}</inlineCode>{` is always required for accessibility:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const renderMarkdown = async markdown => {
  // In production code, this would make a query to some external API endpoint to render
  return 'Rendered Markdown.'
}

const MinimalExample = () => {
  const [value, setValue] = React.useState('')

  return (
    <MarkdownEditor value={value} onChange={setValue} onRenderPreview={renderMarkdown}>
      <MarkdownEditor.Label>Minimal Example</MarkdownEditor.Label>
    </MarkdownEditor>
  )
}

render(MinimalExample)
`}</code></pre>
    <h3>{`Suggestions, File Uploads, and Saved Replies`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const renderMarkdown = async markdown => 'Rendered Markdown.'

const uploadFile = async file => ({
  url: \`https://example.com/\${encodeURIComponent(file.name)}\`,
  file,
})

const emojis = [
  {name: '+1', character: '👍'},
  {name: '-1', character: '👎'},
  {name: 'heart', character: '❤️'},
  {name: 'wave', character: '👋'},
  {name: 'raised_hands', character: '🙌'},
  {name: 'pray', character: '🙏'},
  {name: 'clap', character: '👏'},
  {name: 'ok_hand', character: '👌'},
  {name: 'point_up', character: '☝️'},
  {name: 'point_down', character: '👇'},
  {name: 'point_left', character: '👈'},
  {name: 'point_right', character: '👉'},
  {name: 'raised_hand', character: '✋'},
  {name: 'thumbsup', character: '👍'},
  {name: 'thumbsdown', character: '👎'},
]

const references = [
  {id: '1', titleText: 'Add logging functionality', titleHtml: 'Add logging functionality'},
  {
    id: '2',
    titleText: 'Error: \`Failed to install\` when installing',
    titleHtml: 'Error: <code>Failed to install</code> when installing',
  },
  {id: '3', titleText: 'Add error-handling functionality', titleHtml: 'Add error-handling functionality'},
]

const mentionables = [
  {identifier: 'monalisa', description: 'Monalisa Octocat'},
  {identifier: 'github', description: 'GitHub'},
  {identifier: 'primer', description: 'Primer'},
]

const savedReplies = [
  {name: 'Duplicate', content: 'Duplicate of #'},
  {name: 'Welcome', content: 'Welcome to the project!\\n\\nPlease be sure to read the contributor guidelines.'},
  {name: 'Thanks', content: 'Thanks for your contribution!'},
]

const MinimalExample = () => {
  const [value, setValue] = React.useState('')

  return (
    <MarkdownEditor
      value={value}
      onChange={setValue}
      onRenderPreview={renderMarkdown}
      onUploadFile={uploadFile}
      emojiSuggestions={emojis}
      referenceSuggestions={references}
      mentionSuggestions={mentionables}
      savedReplies={savedReplies}
    >
      <MarkdownEditor.Label>Suggestions, File Uploads, and Saved Replies Example</MarkdownEditor.Label>
    </MarkdownEditor>
  )
}

render(MinimalExample)
`}</code></pre>
    <h3>{`Custom Buttons`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const renderMarkdown = async markdown => 'Rendered Markdown.'

const MinimalExample = () => {
  const [value, setValue] = React.useState('')

  return (
    <MarkdownEditor value={value} onChange={setValue} onRenderPreview={renderMarkdown}>
      <MarkdownEditor.Label visuallyHidden>Custom Buttons</MarkdownEditor.Label>

      <MarkdownEditor.Toolbar>
        <MarkdownEditor.ToolbarButton icon={SquirrelIcon} aria-label="Custom button 1" />
        <MarkdownEditor.DefaultToolbarButtons />
        <MarkdownEditor.ToolbarButton icon={BugIcon} aria-label="Custom button 2" />
      </MarkdownEditor.Toolbar>

      <MarkdownEditor.Footer>
        <MarkdownEditor.FooterButton variant="danger">Custom Button</MarkdownEditor.FooterButton>

        <MarkdownEditor.Action>
          <MarkdownEditor.ActionButton variant="danger">Cancel</MarkdownEditor.ActionButton>
          <MarkdownEditor.ActionButton variant="primary">Submit</MarkdownEditor.ActionButton>
        </MarkdownEditor.Action>
      </MarkdownEditor.Footer>
    </MarkdownEditor>
  )
}

render(MinimalExample)
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      